import http from '@gp/utils/httpTS';

import type {
  IGRAction,
  IMilestone,
} from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';
import type { IMilestoneFinancialForecastServerDTO } from '@gp/types/milestones';
import type { IBaseResponse } from '@home/types/common';

export type IMilestoneReq = Omit<
  IMilestone,
  | 'project_id'
  | 'gate_review'
  | 'gate_review_status'
  | 'action_items'
  | 'material'
  | 'man_month'
  | 'progress'
  | 'is_del'
  | 'key_milestones_financial_forecast'
> & {
  project_id: string;
  gate_review: number | null;
  gate_review_status: number | null;
  action_items: string;
  action_item_list: IGRAction[] | null;
  material: string;
  start_date: string;
  start_date_confirm: number;
  milestone_date_change: number;
  milestone_date_reason: string;
  man_month: number | null;
  progress: number | null;
  is_del: number | null;
  key_milestones_financial_forecast:
  | IMilestoneFinancialForecastServerDTO[]
  | null;
};

/**
 * 获取project下的milestones集合
 * @param params.id projectId
 * @returns 当前project下的milestones集合
 */
export const fetchProjectMilestones = async (params: {
  id: number;
}): IBaseResponse<{
  list: IMilestone[];
  latest_edition: any;
}> =>
  http({
    url: '/api/v1/globalpedia_pc/project/milestonesV2',
    method: 'get',
    params,
    rawData: true,
  }) as any;

/**
 * 更新milestones集合
 * @param params.studio_id studioId
 * @param params.project_id projectId
 * @param params.next_milestone_id nextMilestoneId
 * @param params.milestoneList milestones集合
 */
export const updateProjectMilestones = async (params: {
  studio_id: string;
  project_id: string;
  next_milestone: string;
  editing_milestone_id: string;
  milestoneList: IMilestoneReq[];
}): IBaseResponse<any> =>
  http({
    url: '/api/v1/globalpedia_pc/project/milestone_edit ',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;

export const fetchMilestoneEditServerTime = (params: {
  projectId: string;
  studioId: string;
}) =>
  http({
    method: 'post',
    url: '/api/v1/globalpedia_pc/project/before_milestone_edit',
    params,
    rawData: true,
  });

export const fetchMilestoneMilestoneMeetingEdit = async (params: any) =>
  http({
    url: '/api/v1/globalpedia_pc/project/milestone_meeting_edit',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;
